import { Link } from 'react-router-dom';
import { ArrowLeft01Icon } from 'hugeicons-react';
import '../../Styles/Pricing/ReturnToBuddy.css';

const ReturnToBuddy = () => {
    return (
        <Link to='/' className='return-to-buddy'>
            <ArrowLeft01Icon size={20} />
            <span className='return-to-buddy-text'>Return to <span className='return-to-buddy-text-bold'>Buddy</span></span>
        </Link>
    );
};

export default ReturnToBuddy;
